<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.187.188h19.625v19.625H.187V.188z" />
    <path
      d="M14.498.188c.903 0 1.635.732 1.635 1.634v16.356c0 .903-.732 1.635-1.635 1.635H5.502a1.635 1.635 0 01-1.635-1.635V1.822C3.867.92 4.6.188 5.502.188h8.996zm-7.36 1.634H6.32a.818.818 0 00-.812.722l-.006.097v14.718c0 .42.316.766.722.813l.096.006h7.36c.42 0 .765-.316.812-.722l.006-.097V2.641a.818.818 0 00-.722-.813l-.096-.006h-.819l-.004.096a.82.82 0 01-.718.717l-.094.006h-4.09l-.094-.006a.82.82 0 01-.718-.717l-.004-.096z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
